import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const tiers = [{
  name: 'Scout',
  price: 'Free',
  desc: 'Perfect for rising teams building their profile.',
  features: ['Basic team profile', '3 matches per month', 'Community Discord access', 'Standard analytics'],
  highlight: false
}, {
  name: 'Contender',
  price: '€49',
  period: '/mo',
  desc: 'For established rosters ready to close deals.',
  features: ['Unlimited matches', 'Advanced analytics dashboard', 'Priority listing in brand searches', 'Direct messaging with brands', 'Contract templates'],
  highlight: true
}, {
  name: 'Champion',
  price: '€199',
  period: '/mo',
  desc: 'Enterprise solutions for top-tier organizations.',
  features: ['White-glove matching service', 'Dedicated account manager', 'Custom jersey builder access', 'API access for live stats', 'Legal review assistance'],
  highlight: false
}];
export function Pricing() {
  return <section className="py-24 bg-dark relative" id="pricing" data-id="element-203">
      <div className="container mx-auto px-6" data-id="element-204">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-205">
          <h2 className="font-rajdhani text-4xl md:text-5xl font-bold mb-6" data-id="element-206">
            TRANSPARENT{' '}
            <span className="text-neon-cyan text-glow-cyan" data-id="element-207">PRICING</span>
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-208">
            No hidden fees. No middlemen taking 20% cuts. Just straightforward
            subscriptions.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto items-center" data-id="element-209">
          {tiers.map((tier, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className={`relative bg-dark-card rounded-2xl p-8 border ${tier.highlight ? 'border-neon-cyan shadow-[0_0_30px_rgba(0,243,255,0.15)] md:-translate-y-4' : 'border-white/10'}`} data-id="element-210">
              {tier.highlight && <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-neon-cyan text-dark text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-211">
                  Most Popular
                </div>}

              <h3 className="font-rajdhani text-2xl font-bold mb-2" data-id="element-212">
                {tier.name}
              </h3>
              <p className="text-sm text-gray-400 mb-6 h-10" data-id="element-213">{tier.desc}</p>

              <div className="mb-8" data-id="element-214">
                <span className="font-rajdhani text-5xl font-bold" data-id="element-215">
                  {tier.price}
                </span>
                {tier.period && <span className="text-gray-500" data-id="element-216">{tier.period}</span>}
              </div>

              <button className={`w-full py-3 rounded-md font-bold transition-all mb-8 ${tier.highlight ? 'bg-neon-cyan text-dark hover:shadow-[0_0_20px_rgba(0,243,255,0.4)]' : 'bg-dark-lighter border border-white/20 hover:border-white/50'}`} data-id="element-217">
                Get Started
              </button>

              <ul className="space-y-4" data-id="element-218">
                {tier.features.map((feat, i) => <li key={i} className="flex items-start gap-3 text-sm text-gray-300" data-id="element-219">
                    <Check className={`w-5 h-5 shrink-0 ${tier.highlight ? 'text-neon-cyan' : 'text-gray-500'}`} data-id="element-220" />
                    {feat}
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </section>;
}